export default {
  ruleLabel: "Don’t be shy",
  heading: "Let’s Tell Your Story Together.",
  location: `
    547 West 27th Street
    Suite 310
    New York, NY 10001
  `,

  contactLines: [
    {
      title: "New Business",
      name: "Carson Hood",
      phone: "12125633939",
      email: "carson@bgstr.com",
    },
    {
      title: "General Inquiries",
      phone: "12125633939",
      email: "contact@bgstr.com",
    },
  ],
};
